<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="100"
    height="61.5"
    viewBox="0 0 100 61.5"
  >
    <defs>
      <clipPath id="a">
        <rect class="a" width="100" height="61.5" transform="translate(117 401)" />
      </clipPath>
    </defs>
    <g class="b" transform="translate(-117 -401)">
      <g transform="translate(129.364 401)">
        <rect class="a" width="6.4" height="6.4" transform="translate(27.548 6.886)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(27.548 48.21)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(0 6.886)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(20.662)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(20.662 55.1)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(41.324 6.886)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(41.324 48.21)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(68.872 6.886)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(68.872 48.21)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(0 48.21)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(61.986 13.776)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(6.886 13.776)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(61.986 41.324)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(6.886 41.324)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(55.1 20.662)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(13.776 20.662)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(55.1 34.438)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(13.776 34.438)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(61.986 27.548)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(0 27.548)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(68.872 27.548)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(6.886 27.548)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(48.21)" />
        <rect class="a" width="6.4" height="6.4" transform="translate(48.21 55.1)" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Dead"
};
</script>

<style lang="scss" scoped>
.a {
  fill: #ab90c9;
}
</style>